module.exports = __webpack_public_path__ + "img/ES1555.0e58fe77.svg";